// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ResponseHandler$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";
import * as PartnerPenaltiesEntityMapper from "../entity-mapper/PartnerPenaltiesEntityMapper.bs.js";
import * as EditManualPenaltyEntityMapper from "../entity-mapper/EditManualPenaltyEntityMapper.bs.js";
import * as ManualPenaltyListEntityMapper from "../entity-mapper/ManualPenaltyListEntityMapper.bs.js";

var execute = ManualPenaltyListEntityMapper.execute;

var ManualPenaltyListResponseConverterConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var ManualPenaltyListResponseConverter = partial_arg(ManualPenaltyListResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$1 = EditManualPenaltyEntityMapper.execute;

var EditManualPenaltyResponseConverterConfig = {
  execute: execute$1
};

var partial_arg$1 = ResponseHandler$Catalyst.ResponseConverter;

var EditManualPenaltyResponseConverter = partial_arg$1(EditManualPenaltyResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$2 = PartnerPenaltiesEntityMapper.execute;

var PartnerPenaltyResponseConverterConfig = {
  execute: execute$2
};

var partial_arg$2 = ResponseHandler$Catalyst.ResponseConverter;

var PartnerPenaltyResponseConverter = partial_arg$2(PartnerPenaltyResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  ManualPenaltyListResponseConverterConfig ,
  ManualPenaltyListResponseConverter ,
  EditManualPenaltyResponseConverterConfig ,
  EditManualPenaltyResponseConverter ,
  PartnerPenaltyResponseConverterConfig ,
  PartnerPenaltyResponseConverter ,
  
}
/* ManualPenaltyListResponseConverter Not a pure module */
